<template>
  <div class="tabla-contenedor">
    <div class="titulo">
      {{ titulo_variante }} {{ titulo_estado }}
      <button class="btn m-l-1" type="button" @click="descargar">Descargar</button>
    </div>

    <div class="tabla a11y-simplificada-none" @scroll="scrollTabla">
      <table>
        <thead>
          <tr>
            <th>Posición</th>
            <th>Fecha de recolección</th>
            <th>Estado</th>
            <th>Municipio</th>
            <th>Laboratorio que secuenció</th>
            <th>Estatus paciente</th>
            <th>Variante</th>
            <th>OMS</th>
            <th>Linaje Pangolin</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in datos_tabla_parcial" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ row.fecha_recoleccion }}</td>
            <td>{{ row.estado }}</td>
            <td>{{ row.municipio }}</td>
            <td>{{ row.laboratorio_secuencio }}</td>
            <td>{{ row.estatus_paciente }}</td>
            <td>{{ row.tipo_variante }}</td>
            <td>{{ row.variante_oms }}</td>
            <td>{{ row.linaje_pangolin }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConsorcioTabla from "@/assets/datasets/consorcio_tabla.json";
import Estados from "@/assets/data/estados.json";
import Variantes from "@/assets/data/variantes.json";

export default {
  name: "TablaDatosDescarga",
  computed: {
    ...mapState(["variante_seleccionada", "estado_seleccionado"]),
    varianteSeleccionada() {
      return this.$store.getters.varianteSeleccionada;
    },
    estadoSeleccionado() {
      return this.$store.getters.estadoSeleccionado;
    },
  },
  watch: {
    variante_seleccionada(nuevaVariante) {
      this.filtrarDatos(nuevaVariante, this.$store.getters.estadoSeleccionado);
    },
    estado_seleccionado(nuevoEstado) {
      this.filtrarDatos(this.$store.getters.varianteSeleccionada, nuevoEstado);
    },
  },
  methods: {
    filtrarDatos(variante, estado) {
      const varianteObj = this.lista_variantes.filter((v) => v.clave === variante);
      const estadoObj = this.lista_estados.filter((e) => e.clave === estado);
      this.titulo_variante = varianteObj[0].nombre;
      if (variante === "VTODAS") {
        this.datos_tabla = this.datos_completos;
        this.datos_tabla_parcial = this.datos_tabla;
      } else {
        this.datos_tabla = this.datos_completos.filter((row) => row.tipo_variante === variante);
        this.datos_tabla_parcial = this.datos_tabla;
      }
      if (estado === "00") {
        this.titulo_estado = "a nivel nacional";
      } else {
        this.titulo_estado = `en ${estadoObj[0].nombre}`;
        this.datos_tabla = this.datos_tabla.filter((row) => row.estado === estadoObj[0].nombre);
        this.datos_tabla_parcial = this.datos_tabla;
      }
    },
    scrollTabla() {
      // eslint-disable-next-line max-len
      this.filtrarDatos(
        this.$store.getters.varianteSeleccionada,
        this.$store.getters.estadoSeleccionado
      );
    },
    descargar() {
      let filename = `${this.titulo_variante}-${this.titulo_estado}.csv`;
      filename = filename.toLowerCase();
      filename = filename.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      filename = filename.replace(/\s/g, "-");
      const fields = Object.keys(this.datos_tabla[0]);
      const BOM = "\uFEFF";
      let csvData = this.datos_tabla.map((row) =>
        fields.map((fieldName) => JSON.stringify(row[fieldName])).join(",")
      );
      csvData.unshift(fields.join(","));
      csvData = csvData.join("\r\n");
      const csvFile = BOM + csvData;
      const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
  },
  data() {
    return {
      titulo_estado: "a nivel nacional",
      titulo_variante: "Todas las variantes",
      datos_tabla: [],
      datos_tabla_parcial: [],
      datos_completos: ConsorcioTabla,
      lista_estados: Estados,
      lista_variantes: Variantes,
      slice_datos: 100,
      pagina_datos: 1,
    };
  },
  mounted() {
    const fragmento = parseInt(this.slice_datos * this.pagina_datos, 10);
    this.datos_tabla = this.datos_completos;
    this.datos_tabla_parcial = this.datos_completos.slice(0, fragmento);
  },
};
</script>

<style lang="scss" scoped>
.tabla-contenedor {
  .titulo {
    font-size: 16px;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    padding: 5px 10px;
  }
  .tabla {
    max-height: 283px;
    width: 100%;
    overflow: auto;
    border-bottom: 1px solid #000;
    table {
      border-collapse: collapse;
      font-weight: 400;
      width: 100%;
      margin: 0;
      th {
        font-size: 12px;
        line-height: 14px;
        font-weight: 600;
        border-bottom: none;
        padding: 10px;
        vertical-align: bottom;
      }
      td {
        font-size: 12px;
        line-height: 14px;
        font-weight: 400;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        white-space: nowrap;
      }
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      table {
        th {
          padding: 20px 10px;
        }
        td {
          padding: 10px;
        }
      }
    }
  }
}
</style>
